import React from "react";
import { Link } from "react-router-dom";

export default function PlaceholderPage({ moduleName, testid }) {
    return (
        <div className="p-6 md:p-10" data-testid={testid}>
            <div className="max-w-3xl">
                <div className="overline">Coming in next phase</div>
                <h1 className="mt-3 font-display text-4xl md:text-5xl tracking-tight leading-none">{moduleName}</h1>
                <p className="mt-4 text-muted-foreground">
                    The {moduleName} module is scaffolded and will be delivered in the next Release 1 build phase. Foundation, auth, branding, and public marketing are already live.
                </p>
                <div className="mt-8 border border-border p-6">
                    <div className="overline">In the meantime</div>
                    <ul className="mt-4 space-y-3 text-sm">
                        <li className="flex justify-between border-b border-border pb-3">
                            <span>Configure organization branding</span>
                            <Link to="/app/settings/branding" className="underline text-muted-foreground hover:opacity-70">Go →</Link>
                        </li>
                        <li className="flex justify-between border-b border-border pb-3">
                            <span>Invite teammates</span>
                            <Link to="/app/settings/users" className="underline text-muted-foreground hover:opacity-70">Go →</Link>
                        </li>
                        <li className="flex justify-between">
                            <span>Review subscription</span>
                            <Link to="/app/settings/subscription" className="underline text-muted-foreground hover:opacity-70">Go →</Link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}
